import { render } from "./dqj.vue?vue&type=template&id=b16849f6"
import script from "./dqj.vue?vue&type=script&lang=js"
export * from "./dqj.vue?vue&type=script&lang=js"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__